import { parseRoute } from "./route.ts";

const STORE_KEY = "filmsquare.dailies.unsubscribe";
export const UNSUBSCRIBE_HASH = "#/dailies/unsubscribe";
type TokenStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function browserStorage(): TokenStorage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

/** Keep the credential in this tab before scrubbing it; recover it only on the scrubbed route. */
export function captureUnsubscribeToken(
  hash: string,
  storage: TokenStorage | null = browserStorage(),
): string | null {
  const route = parseRoute(hash);
  if (route.view === "dailies-unsubscribe") {
    try {
      storage?.setItem(STORE_KEY, route.token);
    } catch {
      // Storage blocked: the current screen can still keep the token in React state.
    }
    return route.token;
  }
  if (hash === UNSUBSCRIBE_HASH) {
    try {
      return storage?.getItem(STORE_KEY) || null;
    } catch {
      // Storage blocked: there is no saved token to recover.
    }
  }
  return null;
}

/** An older request must not clear a newer link opened in the same tab. */
export function clearUnsubscribeToken(token: string, storage: TokenStorage | null = browserStorage()): void {
  try {
    if (storage?.getItem(STORE_KEY) === token) storage.removeItem(STORE_KEY);
  } catch {
    // Storage may be blocked.
  }
}
